import { Skeleton } from '@mui/material';
import Grid from '@mui/material/Grid2';

export function TeamMemberContentSkeleton() {
  return (
    <Grid container spacing='26px'>
      {[1, 2, 3].map((item) => (
        <Grid size={12} key={item}>
          <Skeleton variant='text' width={60} height={20} sx={{ mb: 1 }} />
          <Skeleton variant='rectangular' height={56} sx={{ borderRadius: 1 }} />
        </Grid>
      ))}
    </Grid>
  );
}

export function TeamMemberFooterSkeleton() {
  return (
    <>
      <Skeleton variant='rectangular' width={80} height={40} sx={{ borderRadius: 1 }} />
      <Skeleton variant='rectangular' width={80} height={40} sx={{ borderRadius: 1 }} />
    </>
  );
}
